module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_02-f2919c46ce424163b62e08cfd1766ac5.jpg";